import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeofenceService } from '@app-asset-config/services/geofence.service';
import { TaggingService } from '@app-asset-config/services/tagging.service';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-geofence-asset-tag-list',
  templateUrl: './geofence-asset-tag-list.component.html',
  styleUrls: ['./geofence-asset-tag-list.component.scss'],
})
export class GeofenceAssetTagListComponent implements OnInit {
  @Input() mode: 'list' | 'multiselect' = 'multiselect';
  @Input() preSelect: number[] = [];

  public preSelected: number[] = [];

  @Output() selected = new EventEmitter();

  public attrGroupedTagList: any[] = [];

  constructor(private geofenceService: GeofenceService, private taggingService: TaggingService, public dataService: DataService) {}

  ngOnInit(): void {
    this.fetchTags();
    this.preSelected = [...this.preSelect];
  }

  fetchTags() {
    const params: any = {
      limit: 500,
      offset: 0,
      'entityNames[]': ['asset'],
      attributeType: 'DATA',
    };
    this.taggingService.getAttributes(params).subscribe((res) => {
      const groupedTagList = [];

      res.data.forEach((attr: any) => {
        // if (attr.status !== "ACTIVE") return;

        const attrName = attr.attributeName;

        const tags = [];

        (attr.tags || []).forEach((tag: any) => {
          // if (tag.tagStatus != "ACTIVE" || tag.entityName !== "asset") return;
          if (tag.entityName !== 'asset') return;
          tags.push(tag);
        });

        if (!tags.length) return;

        groupedTagList.push({
          attrName,
          tags,
        });
      });

      this.attrGroupedTagList = [...groupedTagList];
    });
  }

  onCheckboxChange(event: any, tagId: number) {
    if (event.checked) {
      if (!this.preSelected.includes(tagId)) {
        this.preSelected.push(tagId);
      }
    } else {
      const index = this.preSelected.indexOf(tagId);
      if (index > -1) {
        this.preSelected.splice(index, 1);
      }
    }
  }

  goBack() {
    this.geofenceService.pop();
  }

  isChecked(tagId: number): boolean {
    return this.preSelected.includes(tagId);
  }

  unSelectAll() {
    this.preSelected = [];
  }

  updateTagFilter() {
    this.selected.emit(this.preSelected);
    this.goBack();
  }
}
